export const expensesImport = [
  {
    "Date Paid": "2022-11-12T12:00:00.000",
    "Payment Due": "2022-11-01T12:00:00.000",
    Cost: 117.4,
    Notes: "Two vans needed a top up",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T19:07:14.714Z",
    "Updated At": "2022-11-10T20:02:14.440Z",
    type: "row",
    "Expense Tags": ["Fuel", "Equipment"],
  },
  {
    "Date Paid": "2022-11-11T12:00:00.000",
    Cost: 217,
    Notes: "3 branded work bags and safety equipment for the new hires",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T19:10:35.459Z",
    "Updated At": "2022-11-10T19:10:35.459Z",
    type: "row",
    "Expense Tags": ["Materials"],
  },
  {
    "Date Paid": "2022-11-25T12:00:00.000",
    Cost: 420.68,
    Notes: "Monthly games night",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T19:20:08.264Z",
    "Updated At": "2022-11-10T19:27:14.141Z",
    type: "row",
    "Expense Tags": ["Food"],
  },
  {
    "Date Paid": "2022-11-24T12:00:00.000",
    "Payment Due": "2022-11-24T12:00:00.000",
    Cost: 45,
    Notes: "Work van",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T18:20:16.709Z",
    "Updated At": "2022-11-10T20:02:05.293Z",
    type: "row",
    "Expense Tags": ["Fuel", "Equipment"],
  },
  {
    "Payment Due": "2022-11-25T12:00:00.000",
    Cost: 200,
    Notes: "Accountant payroll management",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T19:06:16.014Z",
    "Updated At": "2022-11-10T19:06:16.014Z",
    type: "row",
    "Expense Tags": ["Fees", "Service"],
  },
  {
    "Payment Due": "2022-11-26T12:00:00.000",
    Cost: 28,
    Notes: "Circular saw needed a new plug",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T20:03:18.051Z",
    "Updated At": "2022-11-10T20:03:18.051Z",
    type: "row",
    "Expense Tags": ["Equipment", "Repair"],
  },
  {
    "Payment Due": "2022-11-11T12:00:00.000",
    Cost: 131.75,
    Notes: "Solicitor contract reviews for employees",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T18:56:16.111Z",
    "Updated At": "2022-11-10T19:20:58.681Z",
    type: "row",
    "Expense Tags": ["Fees", "Service"],
  },
  {
    Cost: 2500,
    Notes: "New Laptop for the office. ",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T18:04:11.401Z",
    "Updated At": "2022-11-10T20:08:16.459Z",
    type: "row",
    "Date Paid": "2022-11-09T12:00:00.000",
    "Expense Tags": ["Equipment"],
  },
  {
    "Date Paid": "2022-10-25T12:00:00.000",
    Cost: 275,
    Notes: "Accountant payroll. Added new hire",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T20:01:31.783Z",
    "Updated At": "2022-11-10T20:01:31.783Z",
    type: "row",
    "Expense Tags": ["Fees", "Service"],
  },
  {
    "Payment Due": "2022-11-19T12:00:00.000",
    Cost: 250,
    Notes: "200 new branded pens and 40 beanie hats. ",
    Attachment: [],
    tableId: "ta_bb_expenses",
    "Created At": "2022-11-10T19:09:08.074Z",
    "Updated At": "2022-11-10T19:09:08.074Z",
    type: "row",
    "Expense Tags": ["Service"],
  },
]
